import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Switch,
  message,
  Card,
  Row,
  Col,
  Select,
} from "antd";
import { useNavigate } from "react-router-dom";
import api from "../../api";

const { TextArea } = Input;
const { Option } = Select;

const AddCustomerPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // تبدیل مقدار has_bought به 0 یا 1
      values.has_bought = values.has_bought ? 1 : 0;

      await api.post("/panel/call-center-request", values);
      message.success("مشتری با موفقیت افزوده شد");
      navigate("/call_center");
    } catch (error) {
      console.error("Error adding customer:", error);
      message.error("خطا در افزودن مشتری");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/call_center"); // بازگشت به صفحه‌ی قبلی
  };

  return (
    <Card>
    <h1 className="text-2xl font-bold mb-10">افزودن درخواست جدید</h1>
    <Form form={form} onFinish={onFinish} layout="vertical">
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="part_name"
            label="نام قطعه"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="part_position"
            label="موقعیت مکانی قطعه"
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
  
      {/* ردیف ۲: کد فنی قطعه و برند خودرو */}
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="product_technical_code"
            label="کد فنی قطعه"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="car_brand"
            label="برند خودرو"
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
  
      {/* ردیف ۳: مدل خودرو و سال ساخت و شماره شاسی خودرو */}
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="car_model"
            label="مدل خودرو و سال ساخت"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="chassis_number"
            label="شماره شاسی خودرو"
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
  
      {/* ردیف ۴: نام و نام خانوادگی و شماره موبایل */}
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="full_name"
            label="نام و نام خانوادگی"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="number"
            label="شماره موبایل"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
  
      {/* ردیف ۵: شماره ثابت و آدرس */}
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="landline"
            label="شماره ثابت"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="address"
            label="آدرس"
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
  
      {/* ردیف ۶: وضعیت و منجر به فروش شد */}
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="status"
            label="وضعیت"
          >
            <Select placeholder="وضعیت را انتخاب کنید">
              <Option value="pending">در انتظار</Option>
              <Option value="priced">قیمت‌گذاری شده</Option>
              <Option value="completed">تکمیل شده</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="price"
            label=" قیمت"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item
            name="has_bought"
            label=""
            valuePropName="checked"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            <div className="flex gap-32">
              <span style={{ marginRight: 8 }}>منجر به فروش شد؟</span>
              <Switch />
            </div>
          </Form.Item>
        </Col>
      </Row>
  
      {/* ردیف ۷: توضیحات */}
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            name="body"
            label="توضیحات"
          >
            <TextArea rows={4} />
          </Form.Item>
        </Col>
      </Row>
  
      {/* دکمه‌های ذخیره و انصراف */}
      <Form.Item>
        <Row gutter={16}>
          <Col>
            <Button type="primary" htmlType="submit" loading={loading}>
              ذخیره
            </Button>
          </Col>
          <Col>
            <Button onClick={handleCancel}>انصراف</Button>
          </Col>
        </Row>
      </Form.Item>
    </Form>
  </Card>
  );
};

export default AddCustomerPage;
